import React, { useContext, useEffect, useState } from "react";
import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import { postList } from "Apis/post";
import MDBox from "components/MDBox";
import PostForm from "./Form/post";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { getPostById } from "Apis/post";
import { deletePostById } from "Apis/post";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import MDActionButton from "components/MDActionButton";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";

const Posts = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    setPostEditData,
    modules,
    getModuleAccess,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
    access,
  } = useContext(LoginFormContext);
  const [post, setPost] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    description: "",
    title: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      description: filterVal.description,
      title: filterVal.title,
      is_active: filterVal?.is_active?.value,
    },
  };

  const handlePostList = async () => {
    let response = await postList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setPost(response?.data?.data?.posts?.rows);
      setRowCount(response?.data?.data?.posts?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.POST);
  }, [modules]);

  useEffect(() => {
    handlePostList();
  }, [filterVal, defaultFilter]);

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      let response = await getPostById(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        setPostEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }
    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this member!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let deleteResponse = await deletePostById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            post?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            handlePostList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse.data.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse.data.message,
              open: true,
            });
          }
        }
      });
    }
  };

  let data = {
    isFilter: true,
    columns: [
      // {
      //   Header: "Description",
      //   accessor: "description",
      //   minWidth: "85px",
      //   sort: true,
      //   filterLabel: "Description",
      //   filterAccessor: "description",
      //   filterInputType: SEARCH_INPUT_TYPES.TEXT,
      //   filterHandleChange: handleFilter,
      //   Cell: ({ value }) => (
      //     <div
      //       className="post"
      //       dangerouslySetInnerHTML={{
      //         __html: value && value.length > 150 ? `${value.substring(0, 150)}...` : value,
      //       }}
      //     ></div>
      //   ),
      // },
      {
        Header: "Title",
        accessor: "title",
        minWidth: "85px",
        sort: true,
        filterLabel: "Title",
        filterAccessor: "title",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="posts"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: post,
  };

  return (
    !isLoading && (
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <>
            <MDModal
              hasButton={access?.write_access ?? false}
              btnText="add post"
              modalHead={`${formIsEdit ? "Edit" : "Add"} Post`}
            >
              <PostForm handlePostList={handlePostList} />
            </MDModal>
            <DataTable
              table={data}
              isSorted={false}
              entriesPerPage={true}
              showTotalEntries={true}
              noEndBorder
              canFilter
              rowCount={rowCount}
              getDataList={handlePostList}
              //   canSearch={true}
              tableTitle="Post List"
              defaultFilter={defaultFilter}
              setDefaultFilter={setDefaultFilter}
            />
          </>
        </DashboardLayout>
      </>
    )
  );
};
Posts.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  // memberListing: PropTypes.func,
};
export default Posts;
